module.exports = __webpack_public_path__ + "static/media/bonus-cash-1.5de0d095.png";